module.exports = {
    list: ["OAW-AP5xx", "OAW-AP6xx"]
}